<script setup lang="ts"></script>
<template>
  <div
    class="position-relative d-flex align-items-center justify-content-center lh-1"
  >
    <i class="bi bi-octagon"></i>
    <i
      class="bi bi-percent position-absolute start-0 top-0 inner-discount-icon"
    ></i>
  </div>
</template>
<style lang="scss">
.inner-discount-icon {
  scale: 0.6;
}
</style>
